var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCpuHpAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 43,
    fill: "none",
    viewBox: "0 0 36 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_10864",
    width: 36,
    height: 42,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M0 0.39624H35.8522V41.7797H0V0.39624Z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_10864)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7AB2CC",
    fillRule: "evenodd",
    d: "M13.8771 0.866071C5.99143 2.449 -0.846948 10.446 0.085412 21.0922C1.01777 31.7388 9.43611 44.7117 28.3446 41.1908C36.1983 39.2969 35.4669 30.6108 35.096 26.328C34.7255 22.0456 37.9833 14.5434 33.2778 7.34715C28.5727 0.151278 19.4308 -0.24891 13.8771 0.866071Z",
    clipRule: "evenodd"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#68A2BD",
    fillRule: "evenodd",
    d: "M6.88376 18.9679C2.85378 21.0025 2.88857 29.5966 7.9128 32.3884C12.9374 35.1803 20.2272 33.5858 21.4257 31.3658C23.233 28.0169 19.004 21.867 14.8713 19.6743C11.3728 17.8184 8.92444 17.9373 6.88376 18.9679Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M9.25058 21.4069C6.22011 22.9371 6.21687 28.7145 9.99525 30.8137C13.774 32.9133 18.6429 31.7754 19.515 30.0906C20.5352 28.1206 18.3655 23.5873 15.2573 21.9382C12.6265 20.5423 10.7852 20.6323 9.25058 21.4069Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#68A2BD",
    fillRule: "evenodd",
    d: "M35.096 26.3279C34.8501 23.4849 36.2003 19.2235 35.7618 14.575C34.8901 13.0923 33.3866 12.5015 31.0231 13.7275C28.4999 15.0362 24.0699 20.3928 26.4944 27.0545C27.3811 29.4913 32.0591 30.323 34.6486 27.5962C34.8205 27.4151 34.9864 27.1813 35.1453 26.9083C35.1288 26.7082 35.1122 26.5125 35.096 26.3279Z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M30.4508 16.2076C28.5582 17.1895 25.8226 20.9596 27.6412 25.9568C28.3066 27.7846 31.2279 28.6567 33.1703 26.611C35.1818 24.4927 36.1825 13.2343 30.4508 16.2076Z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B122E",
    fillRule: "evenodd",
    d: "M31.6122 20.0011C30.8481 20.0645 30.209 20.8637 29.7904 21.4208C29.2338 22.1614 28.7278 23.0231 29.1662 23.9289C29.3005 24.2067 29.6601 24.4111 29.9777 24.3343C30.9695 24.093 31.3347 23.2553 31.632 22.3698C31.8545 21.7073 32.1809 20.7845 31.8387 20.1145C31.7938 20.0265 31.7073 19.9932 31.6122 20.0011Z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B122E",
    fillRule: "evenodd",
    d: "M12.0191 26.7425C12.3277 27.4177 13.2589 27.7632 13.919 28.0104C14.8186 28.3472 15.702 28.6099 16.5308 28.0037C16.7941 27.8107 16.8601 27.4106 16.7242 27.13C16.2857 26.2231 15.3145 26.0677 14.3732 26.017C13.6605 25.979 12.61 25.9572 12.0729 26.4988C12.0061 26.5662 11.9782 26.6534 12.0191 26.7425Z",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#68A2BD",
    fillRule: "evenodd",
    d: "M28.7523 29.5922C28.9213 29.1306 25.0151 22.915 23.6823 23.4115C22.5914 23.8188 21.74 31.716 22.3087 31.8127",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#68A2BD",
    fillRule: "evenodd",
    d: "M25.8498 32.1085C23.1947 32.9113 18.7554 34.2521 19.8678 37.4148C20.8256 40.1369 25.8413 39.0988 27.6559 38.0658C29.2925 37.1347 33.2319 35.9848 32.7752 32.6878C32.3181 29.3908 27.2017 31.7 25.8498 32.1085Z",
    clipRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M25.9416 32.7925C23.9143 33.4054 20.525 34.4293 21.3741 36.8439C22.1054 38.9221 25.9351 38.1297 27.3205 37.3408C28.5704 36.6299 31.5778 35.7519 31.2292 33.2343C30.8805 30.7171 26.9739 32.4803 25.9416 32.7925Z",
    clipRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M24.0615 24.3441C23.2744 24.6373 22.6604 30.3346 23.0705 30.4044C23.4807 30.4737 27.5968 29.1353 27.719 28.8024C27.8407 28.4696 25.0226 23.9859 24.0615 24.3441Z",
    clipRule: "evenodd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD91D",
    fillRule: "evenodd",
    d: "M22.5377 15.6993C22.5616 15.6993 22.5616 15.6632 22.5377 15.6632C22.5138 15.6632 22.5138 15.6993 22.5377 15.6993Z",
    clipRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#68A2BD",
    fillRule: "evenodd",
    d: "M13.613 10.7216C13.1827 10.1004 12.1706 9.84561 11.4312 10.0943C10.2638 10.4873 9.70639 11.6672 10.1544 12.716C10.4423 13.3903 10.9468 14.0612 11.866 13.9955C12.4235 13.9563 13.0504 13.5741 13.4184 13.204C14.135 12.4838 14.1769 11.5358 13.613 10.7216Z",
    clipRule: "evenodd"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#68A2BD",
    fillRule: "evenodd",
    d: "M5.60504 12.0156C4.40984 11.8962 3.21642 12.4712 3.03116 13.4398C2.78856 14.7095 3.99344 15.7772 5.57038 15.9769C6.98633 16.1556 8.04207 15.2729 7.99871 14.2164C7.9558 13.1789 6.9865 12.1535 5.60504 12.0156Z",
    clipRule: "evenodd"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#68A2BD",
    fillRule: "evenodd",
    d: "M5.89432 9.44994C6.26726 9.72572 6.84852 9.77921 7.26353 9.56445C7.80273 9.28551 8.22664 8.75892 8.38965 8.18479C8.53658 7.16144 8 6.35106 7.27729 6.10777C6.7652 5.9164 6.20255 5.96949 5.69571 6.35106C4.60479 7.17323 4.8932 8.70979 5.89432 9.44994Z",
    clipRule: "evenodd"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    fillRule: "evenodd",
    d: "M7.19971 36.2C11.7842 40.4896 18.6991 42.987 28.3447 41.1909C33.2099 40.0173 34.7793 36.2373 35.1818 32.512C32.104 37.1759 29.7309 38.5996 23.3969 39.1519C15.7564 39.8192 12.3125 37.8301 7.19971 36.2Z",
    clipRule: "evenodd",
    opacity: 0.01
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpuHpAvatar);
export default __webpack_public_path__ + "static/media/cpu_hp_avatar.1f7fea6db201743468a4f3ed0ddc1fd8.svg";
export { ForwardRef as ReactComponent };